module.exports = __webpack_public_path__ + "img/blog-4-1.5826da34.webp";